<textarea class="base-text-area"
      [placeholder]="placeholder"
      [value]="value"
      (input)="onInput($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      (keypress)="handleKeyPress($event)"
      [attr.autocomplete]="autocomplete"
      [attr.aria-label]="ariaLabel"
      [attr.maxlength]="maxlength"
      [attr.disabled]="disabled ? true : null"
      [ngClass]="{ 'fluid' : isFluid, 'icon-spacing' : hasIcon}"
      [ngStyle]="{'margin-bottom': mb, 'margin-top': mt, 'height': height}"
    ></textarea>
